import { ethers } from "ethers";

export class EvmWorker {
    provider: ethers.BrowserProvider;
    //signer: ethers.JsonRpcSigner;
    chainId: BigInt = BigInt(1);
    address: string = "";
    addrInt: bigint = BigInt(0);
    coinUnit: string;

    constructor(_coinUnit = "ETH"){
        this.provider = new ethers.BrowserProvider((window as any).ethereum);
        this.coinUnit = _coinUnit;
    }

    async init(requestChainId: BigInt, address: string): Promise<boolean> {
        this.address = address;
        this.addrInt = ethers.getBigInt(address);

        const network = await this.provider.getNetwork();
        if(requestChainId !== network.chainId) {
            return false;
        }
        this.chainId = network.chainId;
        //this.signer = await this.provider.getSigner(address);
        return true;
    }

    // async checkChainId(requestChainId: number){
    //     const network = await this.provider.getNetwork();
    //     if(requestChainId !== network.chainId) {
    //         return false;
    //     }
    //     this.chainId = network.chainId;
    // }

    async getContract(contractAddress: string, abi: any) {
        const signer = await this.provider.getSigner(this.address);
        const c = new ethers.Contract(contractAddress, abi, signer);
        return {
            signer,
            contract: c
        };
    }

    // ---------------------------------------

    async mint(contract: ethers.Contract, mintPrice: string = "0.001", toast: any) {
        try{
            const mintPriceEthers = ethers.parseEther(mintPrice);
            console.log(`mint price: ${mintPriceEthers}`);
            const feeData = await this.provider.getFeeData();
            console.log(`gas price: ${feeData.gasPrice}`);
            const gasLimit = await contract.mint.estimateGas({value: mintPriceEthers});
            console.log(`gas limit: ${gasLimit}`);
            const tx = await contract.mint({
                value: mintPriceEthers,
                gasLimit: gasLimit,
                gasPrice: feeData.gasPrice
            });
            const receipt = await tx.wait();
            if(receipt) {
                return true;
            }
            return false;
        }
        catch(error: any) {
            if(error.code === 4001) {
                toast({
                    title: 'Cancelled!',
                    description: "You cancelled the action!",
                    status: 'warning',
                    duration: 3000,
                    isClosable: true,
                });
            }
            return false;
        }
    }

    async loadTokenImage(contract: ethers.Contract, ethAddress: string): Promise<string> {
        const addrInt = ethers.getBigInt(ethAddress);
        const _tokenUriBase64 = await contract.tokenURI(addrInt);

        const bytes = ethers.decodeBase64(_tokenUriBase64.substring("data:application/json;base64,".length));
        const _tokenUriStr = ethers.toUtf8String(bytes);
        const _tokenUri = JSON.parse(_tokenUriStr);
        console.log(`_tokenUri: ${_tokenUriStr}`);
        const svgBase64 = _tokenUri.image;
        const svgBytes = ethers.decodeBase64(svgBase64.substring("data:image/svg+xml;base64,".length));
        const svg = ethers.toUtf8String(svgBytes);
        return svg;
    }

    async withdrawAll(contract: ethers.Contract, toast: any) {
        try {
            const feeData = await this.provider.getFeeData();
            console.log(`gas price: ${feeData.gasPrice}`);
            const gasLimit = await contract.withdraw.estimateGas();
            console.log(`gas limit: ${gasLimit}`);
            const tx = await contract.withdraw({
                gasLimit: gasLimit,
                gasPrice: feeData.gasPrice
            });
            const receipt = await tx.wait();
            if(receipt){
                toast({
                    title: 'Congratulations!',
                    description: `You have already withdrawn all ${this.coinUnit} in the contract!`,
                    status: 'success',
                    duration: 3000,
                    isClosable: true,
                });
                return true;
            }
            return false;
        }
        catch(error: any) {
            if(error.code === 4001) {
                toast({
                    title: 'Cancelled!',
                    description: "You cancelled the action!",
                    status: 'warning',
                    duration: 3000,
                    isClosable: true,
                });
            }
            return false;
        }
    }
    
    // ---------------------------------------

    static async requestNetwork(requestParams: any) {
        const ethereum = (window as any).ethereum;
        // Check if MetaMask is installed
        // MetaMask injects the global API into window.ethereum
        if (ethereum) {
            try {
                // check if the chain to connect to is installed
                await ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: requestParams.chainId }], // chainId must be in hexadecimal numbers
                });
            } catch (error: any) {
                // This error code indicates that the chain has not been added to MetaMask
                // if it is not, then install it into the user MetaMask
                if (error.code === 4902) {
                    try {
                        await ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [ requestParams ],
                        });
                    } catch (addError) {
                        console.error(addError);
                    }
                }
                else if(error.code !== -32002) {
                    console.log(error);
                }
            }
        } else {
            // if no window.ethereum then MetaMask is not installed
            alert('MetaMask is not installed. Please consider installing it: https://metamask.io');
        } 
    }

    static async getBalanceOf(rpc: string, abi: any, contractAddress: string, ethAddress: string): Promise<number> {
        const p = new ethers.JsonRpcProvider(rpc);
        const contract = new ethers.Contract(contractAddress, abi, p);
        const balanceBigint = await contract.balanceOf(ethAddress);
        return parseInt(`${balanceBigint}`);
    }

    static async checkMinted(rpc: string, abi: any, contractAddress: string, ethAddress: string): Promise<boolean> {
        const str = await EvmWorker.getBalanceOf(rpc, abi, contractAddress, ethAddress);
        console.log(`${rpc}: getBalanceOf(): ${str}`);
        return str === 1;
    }

}